/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Payment_Method_LabelInputs */

const vi_order_export_payment_method_label = /** @type {(inputs: Order_Export_Payment_Method_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương thức thanh toán`)
};

/**

* @param {Order_Export_Payment_Method_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_payment_method_label = /** @type {((inputs?: Order_Export_Payment_Method_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Payment_Method_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_payment_method_label(inputs)
});